export default __webpack_public_path__ + "static/032a-268b860075c59f6f26f8fc6b56632224.jpg";